/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-proxy';
const componentName = 'system-proxy';
const prefix = `${moduleName}.${componentName}`;

export const proxyHeader = `${prefix}.proxyHeader`;
export const systemProxyLabel = `${prefix}.systemProxyLabel`;

export const ENGLISH = {
    [proxyHeader]: 'Proxy',
    [systemProxyLabel]: 'Use Cloud Services Split Proxy',
};
